/**
 * Represents a single render in progress.
 */
export default class RenderInProgress {
  static defaultProps = {
    renderUid: '', // <revision_uuid>-<cameraId>
    cameraId: '', // the camera name for this render
    revisionUuid: '', // design revision UUID
    renderUuid: '', // render Uuid

    // Hotspots that should have spinners while
    // this render is in progress.
    hotspotUuids: [],

    // Products that should have spinners while
    // this render is in progress
    productIds: [],

    // Internal status.
    // One of: NotStarted | InProgress | Complete | Error | Canceled
    status: 'NotStarted',

    // Error type when status is Error
    error: null
  }

  constructor (overrides) {
    this.fields = { ...RenderInProgress.defaultProps, ...overrides };
  }

  /** Creates a new RenderInProgress copy with optional overrides. */
  makeCopy (overrides) {
    return new RenderInProgress({ ...this.fields, ...overrides });
  }

  /**
   * Returns the render UID.
   * @returns {string} renderUid
   */
  renderUid () { return this.fields.renderUid; }

  /**
   * Returns the hotspots that should have spinners
   * while the render is InProgress.
   *
   * @returns {string[]} hotstpotUuids
   */
  hotspotUuids () { return this.fields.hotspotUuids; }

  /**
   * Returns the product IDs that should have spinners
   * while the render is InProgress.
   *
   * @returns {number[]} productIds
   */
  productIds () { return this.fields.productIds; }

  /**
   * Returns the revision UUID.
   * @returns {string} revisionUuid
   */
  revisionUuid () { return this.fields.revisionUuid; }

  /**
   * Returns the render UUID.
   * @returns {string} renderUuid
   */
  renderUuid () { return this.fields.renderUuid; }

  /**
   * Returns whether or not the render is InProgress.
   * @returns {boolean}
   */
  isInProgress () { return this.fields.status === 'InProgress'; }

  /**
   * Returns whether or not the render is Complete.
   * @returns {boolean}
   */
  isComplete () { return this.fields.status === 'Complete'; }

  /**
   * Returns whether or not the render has been canceled.
   * @returns {boolean}
   */
  hasBeenCanceled () { return this.fields.status === 'Canceled'; }

  /**
   * Returns whether or not the render has been failed.
   * @returns {boolean}
   */
  hasFailed () { return this.fields.status === 'Error'; }

  /**
   * Returns the camera ID
   * @returns {string}
   */
  cameraId () { return this.fields.cameraId; }
}
